﻿{
  "community": {
    "name": "Communauté",
    "titles": {
      "1": "Communauté en ligne",
      "2": "Rechercher du matériel",
      "3": "Partager ce que vous avez créé"
    },
    "body": {
      "1": "Un excellent emplacement pour nous rejoindre et découvrir tout ce que Boardmaker a à offrir.",
      "2": "Voir ce que les autres créent et partagent. C’est comme une fenêtre pour découvrir la magie de Boardmaker !",
      "3": "Utiliser votre logiciel Boardmaker favori, télécharger et partager ce que vous avez créé avec le reste de la communauté."
    }
  },
  "personal": {
    "name": "Privé",
    "header": "Comporte toute la communauté, plus :",
    "titles": {
      "1": "Créer, éditer, effectuer et imprimer",
      "2": "Logiciel Boardmaker"
    },
    "body": {
      "1": "Pour un parent ou aide-soignant avec un enfant qui souhaite créer, éditer, effectuer et imprimer des activités",
      "2": "Les comptes comprennent une licence Boardmaker 7 qui peut être installée sur 2 ordinateurs Windows"
    }
  },
  "professional": {
    "name": "Professionnel",
    "header": "Comporte toute le privé, plus :",
    "titles": {
      "1": "Gestion de l’élève",
      "2": "Paramètres individualisés"
    },
    "body": {
      "1": "Pour les instructeurs ayant de 1 à 50 élèves et qui souhaitent affecter des tâches et suivre les données des étudiants",
      "2": "Paramètres d’accès personnalisés pour chaque étudiant"
    }
  },
  "organization": {
    "name": "Organisation",
    "header": "Comporte toute le professionnel, plus :",
    "titles": {
      "1": "Assistance pluridisciplinaire"
    },
    "body": {
      "1": "Tarification dégressive. L’organisation contrôle les informations et plusieurs personnes peuvent affecter des tâches aux mêmes élèves."
    }
  }
}
